import {Component} from '@angular/core';
import {IonApp, IonRouterOutlet} from '@ionic/angular/standalone';
import {addIcons} from 'ionicons';
import {
    alertCircleOutline,
    appsOutline,
    arrowBackCircleOutline,
    arrowDown,
    arrowDownCircleOutline,
    arrowForward,
    arrowUp, bookOutline,
    book,
    bugOutline,
    checkmarkCircleOutline,
    closeCircleOutline,
    helpOutline,
    informationCircleOutline,
    peopleOutline,
    timeOutline,
    warningOutline,
    removeCircleOutline, chevronDownOutline,
    optionsOutline,
    checkmarkDoneCircleOutline
} from 'ionicons/icons';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [IonApp, IonRouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})
export class AppComponent {
    title = 'watcher';

    constructor() {
        addIcons({
            checkmarkCircleOutline, closeCircleOutline, arrowBackCircleOutline, timeOutline,
            alertCircleOutline, warningOutline, arrowDownCircleOutline, informationCircleOutline, arrowForward,
            bugOutline, helpOutline, peopleOutline, appsOutline, arrowUp, arrowDown, bookOutline, book,
            removeCircleOutline, chevronDownOutline, optionsOutline, checkmarkDoneCircleOutline
        });
    }
}
